import React, { useEffect, useState } from "react";
import "../style.css";

import Chart from "chart.js/auto";
import {
  // Chart,
  CategoryScale,
  LinearScale,
  Filler,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);
const color = {
  "WEEKLY MEASUREMENT": "#F2994A",
  PUSHUP: "#7D56A5",
  "NEAR POINT": "#35BFEA"
}

const secondaryColorPlate = {
  "WEEKLY MEASUREMENT": "#f39c12d6",
  PUSHUP: "#9c8cbf",
  "NEAR POINT": "#A1D9F0"
}

const maxValuePerUnit = {
  "WPM": 500,
  "LPM": 100,
  "CM": 55
}
export default function Graph({ allData, graphName, tabUnit, setLastTF, setLastAsses, setLastPUSHUP, counter }) {
  const [dataArr, setDataArr] = useState(allData.output.yValues || []);
  const [stdData, setStdData] = useState(allData.STDArr || []);
  const [cmpData, setCmpData] = useState(allData.CMPArr || []);
  const [labels, setLabels] = useState(allData.output.xValues.map(v => v.substring(0, 5)) || []);
  const [lllabl, setLllabl] = useState([]);
  const [first, setFirst] = useState([]);
  const [second, setSecond] = useState([]);
  const [third, setThird] = useState([]);
  const [maxValue, setMaxValue] = useState(maxValuePerUnit[tabUnit]);
  const [data, setData] = useState(null)

  let mainOrange = color[graphName];
  let secondaryColor = secondaryColorPlate[graphName];
  let mainPurple = color[graphName];
  const options = {
    scales: {
      'x-axis-bar': {
        type: 'category',
        offset: true, // Ensures bars remain centered on their labels
        display: false,
        position: 'bottom'
      },
      'x-axis-line': {
        type: 'category',
        offset: false, // Ensures the line dataset starts at the left wall
        display: false,
        position: 'bottom'
      },
      'x-axis-line2': {
        type: 'category',
        offset: false, // Ensures the line dataset starts at the left wall
        display: false,
        position: 'bottom'
      },
      x: {
        id: 'x-axis-0',
        offset: false,
        // <-- axis is not array anymore, unlike before in v2.x: '[{'
        grid: {
          borderColor: mainOrange, // <-- this line is answer to initial question
          borderWidth: 2,
          display: false,
        },
        ticks: {
          align: 'start'
        },
      },
      y: {
        id: 'y-axis-0',
        // <-- axis is not array anymore, unlike before in v2.x: '[{'
        grid: {
          // color: "rgba(0,255,0,0.1)",
          borderColor: mainOrange, // <-- this line is answer to initial question
          display: false,
          borderWidth: 2,
        },

        min: tabUnit === "CM" ? 3 : 0,
        max: maxValue,
        ticks: {
          // steps: tabUnit === "CM" ? 5 : null,
          // display: tabUnit !== "WPM",
          stepSize: tabUnit === "CM" ? 5 : null
        },
        reverse: tabUnit === "CM",
      },
    },
    responsive: true,
    tension: 0.1,
    showLine: true,
    interaction: {
      intersect: false,
      mode: 'index',
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {

        // displayDuration: 200, // זמן במילישניות

        //fonts of the hover box
        titleFont: {
          family: "commic-sans-ms",
        },
        bodyFont: {
          weight: "bold",
        },
        bodyColor: mainOrange,
        titleColor: "white",
        titleAlign: "center",
        footerSpacing: 7,
        displayColors: false,
        bodyAlign: "center",
        callbacks: {
          // footer: (tooltipItems) => {
          //   console.log("🚀 ~ tooltipItems:", tooltipItems)
          //   let sum = 0;

          //   tooltipItems.forEach(function (tooltipItem) {
          //     sum += tooltipItem.parsed.y;
          //   });
          //   return 'Sum: ' + sum;
          // },
          labelTextColor: function (context) {
            if (tabUnit == "WPM") {

              switch (context.datasetIndex) {
                case 0:
                  return "#01fe1a"

                  break;
                case 1:
                  return secondaryColor

                  break;
                case 2:
                  return "#dc3545"

                default:
                  return mainOrange
                  break;
              }
            }
          },
          label: function (context) {
            let formattedValue = context?.formattedValue;
            if (formattedValue) {
              if (tabUnit == "WPM") {

                switch (context.datasetIndex) {
                  case 0:
                    formattedValue = `${Math.abs(formattedValue - 400).toFixed(1)}  SD`;

                    break;
                  case 1:
                    formattedValue += ` ${tabUnit}`;
                    break;
                  case 2:
                    formattedValue = `${(formattedValue / maxValue) * 100}  CMP`;

                  default:
                    break;
                }
              } else {

                formattedValue += ` ${tabUnit}`;
              }
            }
            return formattedValue;
          },
        },

      },
    }
  }
  //labs = labels = Xvalues
  //data = Yvalues
  // useEffect(() => {
  //   let newLabels = allData.output.xValues.map(v => v.substring(0, 5)) || [];
  //   setLabels(newLabels);
  // }, [allData])
  // const labels = allData.output.xValues.map(v => v.substring(0, 5)) || [];
  useEffect(() => {
    let lllablArr = [];
    let firstArr = [];
    let secondArr = [];
    let thirdArr = [];
    let maximum = maxValue;
    // Process data
    const dataSet = dataArr.map((v, i) => {
      if (v && tabUnit === "WPM" && v < 1800) {
        lllablArr.push(labels[i]);
        firstArr.push(stdData[i]);
        secondArr.push(dataArr[i]);
        thirdArr.push(cmpData[i]);

        if (v > maximum) {
          maximum = Math.round(v);
        }

        return v;
      } else if (tabUnit !== "WPM") {
        lllablArr.push(labels[i]);
        secondArr.push(dataArr[i]);

        if (v > maximum) {
          maximum = Math.round(v);
        }

      }
      return v;
    });

    // Padding logic
    const padArray = (arr, filler = null) => {
      while (arr.length < 10) {
        arr.push(filler);
      }
    };

    if (tabUnit === "WPM") {
      setLastAsses(secondArr[secondArr.length - 1])
    } else if (tabUnit == "CM") {
      setLastTF(secondArr.filter(v => v).pop() || 0)
    } else {
      setLastPUSHUP(secondArr.filter(v => v).pop() || 0)
    }


    padArray(lllablArr, ""); // Add empty labels
    padArray(firstArr, null); // Add null values for `first`
    padArray(secondArr, null); // Add null values for `second`
    padArray(thirdArr, null); // Add null values for `third`

    setMaxValue(maximum)
    setLllabl(lllablArr);
    setFirst(firstArr);
    setSecond(secondArr);
    setThird(thirdArr);
  }, [tabUnit, dataArr]);

  useEffect(() => {
    if (tabUnit !== "WPM") {
      setLabels(allData.output.xValues.map(v => v.substring(0, 5)) || []);

      setDataArr(allData.output.yValues);
    }
  }, [counter])


  useEffect(() => {
    let dataSet;
    if (tabUnit == "WPM") {
      dataSet = {
        labels: lllabl,
        datasets: [
          {
            xAxisID: 'x-axis-line2',
            data: tabUnit == "WPM" ? first.map((v, i) => v ? 400 - v : null) : [],
            borderColor: "#01fe1a66",
            borderWidth: 5,
            pointBorderWidth: 1,
            backgroundColor: "#00000073",
            fill: false,
            pointHoverBorderColor: "#00000073",
            pointHoverBackgroundColor: "white",
            pointHoverBorderWidth: 3,
            pointRadius: 1,
            hitRadius: 1,
            hoverRadius: 1,
            tooltipBackgroundColor: "red",
            spanGaps: true,
            showLine: true,
          },
          {

            xAxisID: 'x-axis-line',
            data: second,
            borderColor: mainOrange,
            borderWidth: 0.85,
            pointBorderWidth: 1,
            backgroundColor: secondaryColor,

            fill: {
              target: "start",

              // below: secondaryChosenColor, 
            },
            pointHoverBorderColor: mainOrange,
            pointHoverBackgroundColor: "white",
            pointHoverBorderWidth: 3,
            pointRadius: 1,
            hitRadius: 1,
            hoverRadius: 1,
            tooltipBackgroundColor: "red",
            spanGaps: true,
          },
          {
            xAxisID: 'x-axis-bar',
            index: 0,
            type: third[0] ? "bar" : "line",
            tooltip: "ccccc",
            data: third[0] ? third.map((v, i) => v ? (v * (maxValue / 10)) : null) : [],
            borderColor: "#dc3545",
            borderWidth: 200,
            barThickness: third[0] ? 100 / third.length : 20,
            pointBorderWidth: 4,
            backgroundColor: "#dc3545",
            fill: false,
            pointHoverBorderColor: mainOrange,
            pointHoverBackgroundColor: "white",
            pointHoverBorderWidth: 6.5,
            pointRadius: 1,
            hitRadius: 3,
            hoverRadius: 6,
            tooltipBackgroundColor: "red",
            spanGaps: true,
            showLine: true,
          },
        ],
      }
    } else {
      dataSet = {
        labels: lllabl,
        datasets: [
          {

            xAxisID: 'x-axis-line',
            data: second,
            borderColor: mainOrange,
            borderWidth: 0.85,
            pointBorderWidth: 1,
            backgroundColor: secondaryColor,

            fill: {
              target: "start",

            },
            pointHoverBorderColor: mainOrange,
            pointHoverBackgroundColor: "white",
            pointHoverBorderWidth: 3,
            pointRadius: 1,
            hitRadius: 1,
            hoverRadius: 1,
            tooltipBackgroundColor: "red",
            spanGaps: true,
          }

        ],
      }
    }
    setData(dataSet);

  }, [second])


  return data ? <Line options={options} data={data} /> : <></>;
}
